import { FC, SVGProps } from 'react'
import { ApartmentIcon, CommercialIcon, GarageIcon, HouseTypeIcon, PlotIcon, RoomIcon } from '@svgs'

const ICONS: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  APARTMENT: ApartmentIcon,
  HOUSE: HouseTypeIcon,
  TOWNHOUSE: HouseTypeIcon,
  DUPLEX: HouseTypeIcon,
  PART_OF_HOUSE: HouseTypeIcon,
  ROOM: RoomIcon,
  PLOT: PlotIcon,
  GARAGE: GarageIcon,
  COMMERCIAL_PROPERTY: CommercialIcon,
}

interface IPropertyTypeIcon extends SVGProps<SVGSVGElement> {
  type?: string
}

// One branded silhouette per property type; unknown types fall back to the
// house so a new enum value never renders an empty slot.
const PropertyTypeIcon: FC<IPropertyTypeIcon> = ({ type, ...props }) => {
  const Icon = (type && ICONS[type]) || HouseTypeIcon
  return <Icon {...props} />
}

export default PropertyTypeIcon
